import React from 'react'

import CreatePlansAndPricingContainer from '../../../Components/settings/PlansAndPricingComponent/CreatePlan'

export default function CreatePlansAndPricingPage() {
    return (
        <div className='page-body'>
            <CreatePlansAndPricingContainer />
        </div>
    )
}
